"use strict";
/**
 * AUTOGENERATED
 *
 * DO NOT MODIFY
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.HU = void 0;
exports.HU = {
    belongsToEU: true,
    belongsToEurope: true,
    subdivisions: {
        'HU-BA': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'HU-BE': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'HU-BK': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'HU-BZ': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'HU-CS': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'HU-FE': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'HU-GS': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'HU-HB': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'HU-HE': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'HU-JN': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'HU-KE': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'HU-NO': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'HU-PE': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'HU-SO': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'HU-SZ': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'HU-TO': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'HU-VA': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'HU-VE': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'HU-ZA': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'HU-BC': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'HU-DE': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'HU-DU': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'HU-EG': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'HU-ER': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'HU-GY': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'HU-HV': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'HU-KM': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'HU-KV': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'HU-MI': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'HU-NK': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'HU-NY': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'HU-PS': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'HU-SD': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'HU-SF': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'HU-SH': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'HU-SK': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'HU-SN': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'HU-SS': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'HU-ST': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'HU-TB': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'HU-VM': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'HU-ZE': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
        'HU-BU': {
            active: true,
            aliases: {
                names: {
                    en: '',
                },
            },
        },
    },
};
//# sourceMappingURL=data:application/json;base64,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